// extracted by mini-css-extract-plugin
export default {"modalButtons":"AddEditWorkExperienceModal-module_modalButtons__iWeoia"};